
/**
 * Patterns for TextField input validation
 * 
 * must be double escaped for use in pattern={...}
 */

type IInputPatternKeys =  'postalCode' | 'number' | 'phone' | 'email' | 'vatNumber' | 'ibanDe' | 'bic' ;


export const inputPatterns = {
    postalCode: "[0-9]{5}",
    number: "\\\d*",
    phone: '[0-9 \\\+\\\-\\\/\\\(\\\)]{6,20}',
    email:  "[a-z0-9!#$%&'*+\\\/=?^_`{|}~-]+(?:\\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?",
    vatNumber: '^(ATU[0-9]{8}|BE[01][0-9]{9}|BG[0-9]{9,10}|HR[0-9]{11}|CY[A-Z0-9]{9}|CZ[0-9]{8,10}|DK[0-9]{8}|EE[0-9]{9}|FI[0-9]{8}|FR[0-9A-Z]{2}[0-9]{9}|DE[0-9]{9}|EL[0-9]{9}|HU[0-9]{8}|IE([0-9]{7}[A-Z]{1,2}|[0-9][A-Z][0-9]{5}[A-Z])|IT[0-9]{11}|LV[0-9]{11}|LT([0-9]{9}|[0-9]{12})|LU[0-9]{8}|MT[0-9]{8}|NL[0-9]{9}B[0-9]{2}|PL[0-9]{10}|PT[0-9]{9}|RO[0-9]{2,10}|SK[0-9]{10}|SI[0-9]{8}|ES[A-Z]([0-9]{8}|[0-9]{7}[A-Z])|SE[0-9]{12}|GB([0-9]{9}|[0-9]{12}|GD[0-4][0-9]{2}|HA[5-9][0-9]{2}))$',
    // iban: '[A-Z]{2}\\\d{13,32}|(?=.{18,42}$)[A-Z]{2}\\\d{2}( )(\\\d{4}\\\x31){2,7}\\\d{1,4}', // don't works for french iban
    ibanDe: 'DE\\\d{2}( )?(\\\d{4}\\\x31){4}\\\d{2}',
    bic: '[A-Z]{6}[A-Z2-9][A-NP-Z0-9][A-Z0-9]{0,3}',
    test: (value: string, type: IInputPatternKeys ) => {
        return new RegExp(inputPatterns[type], "i").exec(value)?.[0] === value;
    }
}

/* * /

const validTestEmails = [
    'test@io.com',
    'test.io@epam.com',
    'test.io.example+today@epam.com',
    'test-io@epam.com',
    'test@io-epam.com',
    'test-io@epam-usa.com',
    '123456789testio@epam2.com',
    '123456789TESTio@epam2.com',
    '123456789TESTio@EPam2.com',
    '123456789TESTio@EPam2.de',
    '123456789TESTio@EPam2.de',
    'user123@email.co.uk',
    'info@sub.domain.com',
    'user_name1234@email-provider.net',
    'name@my-email-provider.xyz',
    '_______@domain.com',
    'john.doe@email.travel',

];

const invalidTestEmails = [
    'test@io', // missing TLD
    'test@io.', // missing TLD
    'test@io@epam.com', // multiple '@' signs
    'test@io..com', // double dots in domain
    'test(io"epam)example]com', // invalid characters in local part
    'test.io@epam..com',    // double dots in domain
    'test"io"epam.com', // invalid characters in local part
    '.test... io\today@epam.com',
    'user@invalid-tld.123', // invalid TLD -> passes -> RegExp and Chrome type="email" allows numbers in TLD
    'user#domain.com',  // invalid character '#' 
    // 'user&name@email-provider.net', // invalid character '&' -> passes -> this is a valid email address
    'spaced user@domain.info',
    'double..dots@email.org',
    '@.com',
    'user@domain with space.com',
    'user@domain..com'
];

const testEmailPatterns = () => {
    validTestEmails.forEach(email => {
        console.debug(`Testing valid email: ${email}`);
        if (!inputPatterns.test(email, 'email')) {
            console.error(`Valid email failed: ${email}`);
        }
    });

    invalidTestEmails.forEach(email => {
        console.debug(`Testing invalid email: ${email}`);
        if (inputPatterns.test(email, 'email')) {
            console.error(`Invalid email passed: ${email}`);
        }
    });
};

testEmailPatterns();


/* */
